import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  /** Base: sin overflow aquí; welcome vs. vista con chats en variantes */
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    padding: theme.spacing(2),
    border: "1px solid rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  /** Sin conversaciones: el propio Paper hace scroll (zoom / pantallas bajas) */
  mainContainerWelcome: {
    flex: "1 1 auto",
    minHeight: 0,
    maxHeight: "100%",
    overflowX: "hidden",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    alignSelf: "stretch",
  },
  /** Con lista + mensajes: altura fija al panel y scroll solo dentro de columnas */
  mainContainerWithChats: {
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
  },
  /** Encadena flex desde layout main → Paper (altura limitada y scroll correcto) */
  chatPageOuter: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    width: "100%",
    maxWidth: "100%",
    maxHeight: "100%",
    alignSelf: "stretch",
  },
  gridContainer: {
    flex: 1,
    minHeight: 0,
    width: "100%",
    height: "100%",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    backgroundColor: theme.palette.dark,
  },
  tabLayoutRoot: {
    flex: 1,
    minHeight: 0,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  chatColumn: {
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    height: "100%",
  },
  messagesColumn: {
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    height: "100%",
  },
  gridItem: {
    height: "100%",
    minHeight: 0,
  },
  gridItemTab: {
    flex: 1,
    minHeight: 0,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  btnContainer: {
    textAlign: "right",
    padding: 10,
    flexShrink: 0,
    width: "100%",
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      padding: theme.spacing(1),
      "& .MuiButton-root": {
        width: "100%",
        maxWidth: "100%",
      },
    },
  },
  welcomeCardActions: {
    justifyContent: "center",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  welcomePrimaryButton: {
    width: "100%",
    maxWidth: 420,
    [theme.breakpoints.up("sm")]: {
      width: "auto",
    },
  },
  welcomeRoot: {
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    minWidth: 0,
  },
  welcomeTitle: {
    wordBreak: "break-word",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
    },
  },
  dialogActionsResponsive: {
    flexWrap: "wrap",
    gap: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      padding: theme.spacing(2),
    },
  },
  // ✅ NUEVOS ESTILOS PARA MEJOR UX
  welcomeCard: {
    marginBottom: theme.spacing(3),
    background: `linear-gradient(135deg, ${theme.palette.primary.main}15, ${theme.palette.secondary.main}15)`,
    border: `1px solid ${theme.palette.primary.main}30`,
  },
  welcomeHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  welcomeIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  featureCard: {
    marginBottom: theme.spacing(2),
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: theme.shadows[4],
    },
  },
  featureIcon: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  selectedUsers: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  // ✅ CORREGIDO: HelpSection dinámico según tema
  helpSection: {
    backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.grey[50],
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(2),
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
  },
  // ✅ CORREGIDO: DialogTitle dinámico según tema (mantiene color primario)
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    padding: theme.spacing(2),
    margin: theme.spacing(-2, -2, 2, -2),
    boxShadow: theme.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.1)',
  },
  // ✅ CORREGIDO: DialogContent dinámico según tema
  dialogContent: {
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  // ✅ CORREGIDO: SectionTitle dinámico según tema
  sectionTitle: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  // ✅ CORREGIDO: StepCard dinámico según tema
  stepCard: {
    marginBottom: theme.spacing(2),
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    boxShadow: theme.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.08)',
  },
  // ✅ CORREGIDO: TextField dinámico según tema
  textField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      '&.Mui-focused': {
        backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
        boxShadow: `0 0 0 2px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.3)' : 'rgba(25, 118, 210, 0.2)'}`,
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
  },
  // ✅ CORREGIDO: UserChip dinámico según tema
  userChip: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    border: `1px solid ${theme.palette.primary.main}`,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  // ✅ CORREGIDO: ListItem dinámico según tema
  listItem: {
    backgroundColor: theme.mode === 'dark' ? 'transparent' : 'transparent',
    '&:hover': {
      backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#f5f5f5',
    },
  },
  // ✅ CORREGIDO: ListItemText dinámico según tema
  listItemText: {
    '& .MuiTypography-root': {
      color: theme.palette.text.primary,
    },
    '& .MuiTypography-body2': {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
  },
}));
